import { Component, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../shared/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

/**
 * Continue component
 */
@Component({
  selector: 'app-continue',
  templateUrl: './continue.component.html',
  styleUrls: ['./continue.component.scss'],
})
export class ContinueComponent implements OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
    private userService: UserService,
  ) {
    this.activeRoute.params.takeUntil(this.ngUnsubscribe).subscribe((params) => {
      /** Set users selected language for text translations */
      this.translateService.setDefaultLang(params.language);
      this.translateService.use(params.language);

      this.userService
        /** Trigger reactivation */
        .reactivateUser(params.token)
        .catch((error: Error) => {
          /** On error go to login page */
          this.router.navigate(['/login']);
        });
    });
  }

  /**
   * On destroy cancel active subscriptions
   */
  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/continue/continue.component.ts